<template>
    <div>

        111
        <video style="display: none;"></video>
        <div id="video_time">
            video_time:{{ video_time }}
        </div>
    </div>
</template>


<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）

export default {
    name: '',
    components: {

    },
    // 定义属性
    data() {
        return {
            video_time: 0
        }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        hq() {
            let url = this.$route.query.url; // John
            // var url = 'https://bdown.kissxx.cn:7001/21/upload/6d1ccee0-b2e6-7313-f528-d2105afc513e.MP4'
            if (!url) return 0;
            this.getVideoDuration(url).then(duration => {
                console.log(duration)
                this.video_time = duration
                // console.log(`视频 ${index + 1} 的时长为：${duration} 秒`);
                // durations.push(duration);
                // index++;
                // getNextDuration(); // 递归调用以获取下一个视频的时长
            }).catch(error => {
                console.error('获取视频时长时发生错误:', error);
            });
        },
        getVideoDuration(videoUrl) {
            return new Promise((resolve, reject) => {
                // 首先，重置视频元素的src属性
                var videoElement = document.querySelector('video');
                videoElement.src = videoUrl;

                // 监听视频的loadedmetadata事件，该事件在视频元数据加载完成后触发
                videoElement.addEventListener('loadedmetadata', function () {
                    // 视频时长可以通过videoElement.duration获取
                    resolve(videoElement.duration);
                }, { once: true }); // 使用{ once: true }确保事件只监听一次

                // 重新加载视频
                videoElement.load();
            });
        },

        clickVal() {
            console.log('c')
            // uni.postMessage({
            //     data: {
            //         text: '我传参怎么了，我传参怎么了，我传参怎么了。',
            //     }
            // })
            uni.navigateTo({ url: '/pages/index/index' })
            uni.postMessage({
                data: {
                    text: '我传参怎么了，我传参怎么了，我传参怎么了。',
                }
            })
        }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.hq()
    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { }, // 生命周期 - 销毁完成
    activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/components/tu/index.vue